export default __webpack_public_path__ + "static/media/ic_hotline.1233cca1.svg";